import React from "react";
import { useMutation } from "@apollo/client";
import { message } from "antd";
import { useTranslation, Trans } from "react-i18next";

// graphql
import CANCEL_CLASS from "graphql/mutations/CancelClass";
import GET_MY_CLASSES from "graphql/queries/GetMyClasses";
import GET_CLASS_DETAILS from "graphql/queries/GetClassDetails";
import GET_NAVBAR_INFO from "graphql/queries/GetNavbarInfo";

// common
import {
  ModalText,
  ModalLayout,
  LargeModalStyling,
  MoreModalButtons,
} from "common/modal";

const { LargeModal, LargeModalCreditInfo } = LargeModalStyling;
const { ConfirmationText } = ModalText;
const { ModalRow } = ModalLayout;
const { ModalButtonYellow, ModalButtonBlue, ButtonContainer } =
  MoreModalButtons;

type cancelModalType = {
  visible: boolean;
  classId: number;
  onCloseModal: () => void;
};

function CancelModal(props: cancelModalType) {
  const { t } = useTranslation("book_a_class");
  const { visible, onCloseModal, classId } = props;

  const [cancelClass] = useMutation(CANCEL_CLASS, {
    refetchQueries: [
      {
        query: GET_CLASS_DETAILS,
        variables: { id: classId },
      },
      {
        query: GET_MY_CLASSES,
      },
      {
        query: GET_NAVBAR_INFO,
      },
    ],
    onCompleted: () => {
      message.info(t("Your class was canceled."));
    },
    onError: (error) => {
      message.error(error.graphQLErrors[0].message);
    },
  });

  const handleOnClickCancel = () => {
    cancelClass({
      variables: { lessonId: classId },
    });
    onCloseModal();
  };

  return (
    <LargeModal
      title={t("CANCEL BOOKING")}
      centered
      visible={visible}
      footer={null}
      onCancel={onCloseModal}
    >
      <ConfirmationText>
        {t("Do you want to cancel this class?")}
      </ConfirmationText>
      <ModalRow gutter={24}>
        <ButtonContainer xs={20} sm={20} md={12}>
          <ModalButtonYellow
            type="primary"
            onClick={() => {
              handleOnClickCancel();
            }}
          >
            {t("YES, CANCEL")}
          </ModalButtonYellow>
        </ButtonContainer>
        <ButtonContainer xs={20} sm={20} md={12}>
          <ModalButtonBlue
            type="primary"
            onClick={() => {
              onCloseModal();
            }}
          >
            {t("NO, LET'S STUDY")}
          </ModalButtonBlue>
        </ButtonContainer>
      </ModalRow>
      <LargeModalCreditInfo>
        <span>
          <Trans
            t={t}
            i18nKey="You can cancel anytime. Credits are refunded if you cancel within 30 minutes of booking or at least 24 hours before class and before the credit expires."
            components={[<strong />]}
          />
        </span>
      </LargeModalCreditInfo>
    </LargeModal>
  );
}

export default CancelModal;
